module.exports = __webpack_public_path__ + "assets/vitorinofreire-ico-pickdate.f00a95ea.svg";